import React from 'react';

const Landing = () => (
  <section className="displayed-content">
    <h2>Pecos Valley Quality Welding</h2>
    <p>Our name says it all. We have skills and expertise to fabricate your project from start to finish.</p>
    <p>Located in the beutiful Pecos valley in North Eastern New Mexico, Pecos Valley Quality Welding has been serving the community since 2002. </p>  
  </section>
  
);
export default Landing;








// WEBPACK FOOTER //
// ./src/components/Landing.js